import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'babilling_details';
export const route = 'babilling_details/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "billing-details" */
/* webpackPrefetch: true */
'../components/BillingDetailsPage')));